import React from "react";

import PageHeader from "../../components/PageHeader";
import Section from "../../components/Section";

import RegisterForm from "./RegisterForm";
import StuffedList from "./StuffedList";

const StuffedAnimals = ({
  activeLang,
  loggedIn,
  setLoggedInState,
  requestedStuffedIds,
  updateRequestedStuffedIds,
}) => (
  <React.Fragment>
    <PageHeader
      titleKey="Stuffed Animals"
      image="images/papegaai.jpg"
      bgPos="0% 50%"
      activeLang={activeLang}
    />
    {loggedIn ? (
      <Section extraClasses="content-width center p-top__x-large p-bottom__large mobile-p-left__medium mobile-p-right__medium">
        <StuffedList
          activeLang={activeLang}
          requestedStuffedIds={requestedStuffedIds}
          onAddToInquiry={updateRequestedStuffedIds}
        />
      </Section>
    ) : (
      <RegisterForm
        activeLang={activeLang}
        setLoggedInState={setLoggedInState}
      />
    )}
  </React.Fragment>
);

export default StuffedAnimals;
